"use strict";
(function (global) {

 /**
 * Связывает объекты по списку.
 *
 * @function WebAccess.services.relations.bindObjects
 * @param {WA.Link[]} sourceObjects Список ссылок на связываемые объекты
 * @param {WA.Link} destObject Ссылка на объект, с которым связываются объекты из списка
 * @return {Deferred} Deferred-объект, в котором содержится список вставленных ссылок List<ObjectLink> Pasted, список вырезанных ссылок List<ObjectLink> Cutted, список ссылок на объекты, не изменивших состояние связи, и причины List<Tuple<ObjectLink, string>> Unchanged. 
 * @since 5.8.0.3005
 */
  global.relations.bindObjects = function (sourceObjects, destObject) {
    return global.call("/api/Relations.asmx/BindObjects ",
      {
        sourceObjectLinks: sourceObjects,
        destObjectLink: destObject,
      });
  };
  
})(window.WebAccess.services);
